import Tooltip from '@material-ui/core/Tooltip';
import CloseIcon from '@material-ui/icons/Close';
import React, { Component } from 'react';

export class MarkCancelButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      onClick: props.onClick,
      caption: props.caption,
    };
  }

  onClick() {
    if (this.state.onClick) {
      this.state.onClick();
    }
  }
  render() {
    return (
      <span
        onClick={this.onClick.bind(this)}
        style={{ cursor: 'pointer', fontSize: 'x-larger', marginRight: '0.5em', paddingTop: "5px", float: 'right' }}
      >
        <Tooltip title="Mark Cancel">
          <CloseIcon
            style={{
              borderRadius: '25%',
              background: '#867e7e',
              color: 'white',
              padding: '3px',
              fontSize: 'x-large',
              width: '30px',
              minHeight: '30px',
            }}
          />
        </Tooltip>
      </span>
    );
  }
}
export default MarkCancelButton;
